import {Component, Input } from  '@angular/core';
import {DateRange, TopLevelComponent} from '../../shared';
import { Store, StoreHelper, UserService } from '../../shared/services';
import {LocationSale, LocationsFilter, LocationInvoiceDetailFilter} from '../shared';

@Component({
    selector: 'my-location-sale-list',
    styles: [require('./location-sale-list.component.scss')],
    template: require('./location-sale-list.component.pug')
})

export class LocationSaleListComponent extends TopLevelComponent {

    @Input() locationinvoiceOpen: LocationSale[];
    @Input() locationinvoiceClosed: LocationSale[];
    @Input() rangeDate: DateRange;
    @Input() locationFilter: LocationsFilter;
    @Input() empty: boolean;

    showLocationSaleDetails = false;
    selectedLocation: LocationSale;
    private _locationsFilter: LocationsFilter;

    constructor(
        store: Store,
        storeHelper: StoreHelper,
        userService: UserService) {

        super(store, storeHelper, userService);
    }

    showInvoices(locationSale: LocationSale) {

        let filter = new LocationInvoiceDetailFilter(this.locationFilter, locationSale);

        this.storeHelper.update('locationInvoiceDetailFilter', filter);
        this.selectedLocation = locationSale;
        this.showLocationSaleDetails = true;
    }

    locationSaleClosed() {
        this.showLocationSaleDetails = false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/location/location-sale-list/location-sale-list.component.ts